import React from "react";
import { BlogPost } from "../../../../typings/blogs";
import ContentfulImage from "../../../common/utils/ContentfulImage";
import clock from "../../../../assets/images/time-clock.svg";
import { Link } from "react-router-dom";
import Avatar from "../../../common/utils/Avatar";

const BlogCard = ({ blog }: { blog: BlogPost }) => {
  const {
    title,
    slug,
    bannerImage,
    category,
    minuteRead,
    description,
    authorName,
    authorImage,
  } = blog.fields;
  return (
    <Link
      to={`/insights-stories/${encodeURIComponent(slug)}`}
      style={{
        boxShadow: "0px 4px 8px 0px #4682B44D, 0px 4px 12px 0px #4682B433",
      }}
      className="flex bg-textWhite flex-col font-poppins rounded-[10px] gap-4 shadow-custom"
    >
      <ContentfulImage
        src={bannerImage.fields.file.url}
        alt={`author-img ${title}`}
        className="w-full h-[266px] rounded-t-[10px] object-cover"
      />
      <div className="p-5 flex flex-col gap-5 items-start">
        <div className="bg-primary/10 py-0.5 px-3 rounded text-primary text-sm">
          {category}
        </div>
        <div className="flex flex-col gap-3">
          <h3 className="text-textBlack text-[18px] font-medium line-clamp-2">
            {title}
          </h3>
          <span className="text-textBlack text-sm line-clamp-2">
            {description}
          </span>
        </div>
        <div className="flex items-center w-full justify-between">
          <div className="flex gap-2 items-center">
            <Avatar
              src={authorImage.fields.file.url}
              alt={`author-img ${title}`}
              name={authorName}
              className="size-[24px] rounded-full object-cover"
            />
            {/* <ContentfulImage
              src={authorImage.fields.file.url}
              alt={`author-img ${title}`}
              className="size-[24px] rounded-full object-cover"
            /> */}
            <span className="text-textBlack2 text-[14px]">{authorName}</span>
          </div>
          <div className="flex items-center gap-1">
            <img src={clock} className="size-7" alt="" />
            <span className="text-textBlack2 text-[14px]">
              {minuteRead} min read
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
